export const themeDark = {
    name: 'dark',
    className: 'dockview-theme-dark',
    colorScheme: 'dark',
};
export const themeLight = {
    name: 'light',
    className: 'dockview-theme-light',
    colorScheme: 'light',
};
export const themeVisualStudio = {
    name: 'visualStudio',
    className: 'dockview-theme-vs',
    colorScheme: 'dark',
    // --dv-tabs-and-actions-container-height is 20px, but the VS theme applies
    // box-sizing: content-box + border-bottom: 2px, so the rendered strip is 22px.
    edgeGroupCollapsedSize: 22,
};
export const themeAbyss = {
    name: 'abyss',
    className: 'dockview-theme-abyss',
    colorScheme: 'dark',
    tabGroupIndicator: 'none',
};
export const themeDracula = {
    name: 'dracula',
    className: 'dockview-theme-dracula',
    colorScheme: 'dark',
};
export const themeAbyssSpaced = {
    name: 'abyssSpaced',
    className: 'dockview-theme-abyss-spaced',
    colorScheme: 'dark',
    gap: 10,
    edgeGroupCollapsedSize: 44,
    dndOverlayMounting: 'absolute',
    dndPanelOverlay: 'group',
    dndTabIndicator: 'line',
    dndOverlayBorder: '2px solid var(--dv-active-sash-color)',
};
export const themeLightSpaced = {
    name: 'lightSpaced',
    className: 'dockview-theme-light-spaced',
    colorScheme: 'light',
    gap: 10,
    edgeGroupCollapsedSize: 44,
    dndOverlayMounting: 'absolute',
    dndPanelOverlay: 'group',
    dndTabIndicator: 'line',
    dndOverlayBorder: '2px solid var(--dv-active-sash-color)',
};
export const themeNord = {
    name: 'nord',
    className: 'dockview-theme-nord',
    colorScheme: 'dark',
};
export const themeNordSpaced = {
    name: 'nordSpaced',
    className: 'dockview-theme-nord-spaced',
    colorScheme: 'dark',
    gap: 10,
    edgeGroupCollapsedSize: 44,
    dndOverlayMounting: 'absolute',
    dndPanelOverlay: 'group',
    dndTabIndicator: 'line',
    dndOverlayBorder: '2px solid var(--dv-active-sash-color)',
};
export const themeCatppuccinMocha = {
    name: 'catppuccinMocha',
    className: 'dockview-theme-catppuccin-mocha',
    colorScheme: 'dark',
};
export const themeCatppuccinMochaSpaced = {
    name: 'catppuccinMochaSpaced',
    className: 'dockview-theme-catppuccin-mocha-spaced',
    colorScheme: 'dark',
    gap: 10,
    edgeGroupCollapsedSize: 44,
    dndOverlayMounting: 'absolute',
    dndPanelOverlay: 'group',
    dndTabIndicator: 'line',
    dndOverlayBorder: '2px solid var(--dv-active-sash-color)',
};
export const themeMonokai = {
    name: 'monokai',
    className: 'dockview-theme-monokai',
    colorScheme: 'dark',
};
export const themeSolarizedLight = {
    name: 'solarizedLight',
    className: 'dockview-theme-solarized-light',
    colorScheme: 'light',
};
export const themeSolarizedLightSpaced = {
    name: 'solarizedLightSpaced',
    className: 'dockview-theme-solarized-light-spaced',
    colorScheme: 'light',
    gap: 10,
    edgeGroupCollapsedSize: 44,
    dndOverlayMounting: 'absolute',
    dndPanelOverlay: 'group',
    dndTabIndicator: 'line',
    dndOverlayBorder: '2px solid var(--dv-active-sash-color)',
};
export const themeGithubDark = {
    name: 'githubDark',
    className: 'dockview-theme-github-dark',
    colorScheme: 'dark',
};
export const themeGithubDarkSpaced = {
    name: 'githubDarkSpaced',
    className: 'dockview-theme-github-dark-spaced',
    colorScheme: 'dark',
    gap: 10,
    edgeGroupCollapsedSize: 44,
    dndOverlayMounting: 'absolute',
    dndPanelOverlay: 'group',
    dndTabIndicator: 'line',
    dndOverlayBorder: '2px solid var(--dv-active-sash-color)',
};
export const themeGithubLight = {
    name: 'githubLight',
    className: 'dockview-theme-github-light',
    colorScheme: 'light',
};
export const themeGithubLightSpaced = {
    name: 'githubLightSpaced',
    className: 'dockview-theme-github-light-spaced',
    colorScheme: 'light',
    gap: 10,
    edgeGroupCollapsedSize: 44,
    dndOverlayMounting: 'absolute',
    dndPanelOverlay: 'group',
    dndTabIndicator: 'line',
    dndOverlayBorder: '2px solid var(--dv-active-sash-color)',
};
